import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column center>
          <CFView h3 futura bold color="#389E2F" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink href="https://www.facebook.com/lougheedpizzamaru">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Pizza Maru Facebook"
              />
            </CFLink>
            <CFLink href="https://www.instagram.com/pizzamaru_lougheed/?hl=en">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Pizza Maru Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#389E2F" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink href="https://www.facebook.com/lougheedpizzamaru">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Pizza Maru Facebook"
                hover
              />
            </CFLink>
            <CFLink href="https://www.instagram.com/pizzamaru_lougheed/?hl=en">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Pizza Maru Instagram"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
